import Api from '@/Api'
import { contentUrl } from '../config';

const environment = process.env.VUE_APP_CONTENTSTACK_ENVIRONMENT

export default class ContentStackApi extends Api {
  /**
   * Requests the API to fetch read-only content from Contentstack (via apache proxy)
   * @options {Object}          options - key/value pair to be provided as url query parameters
   */

  getContentStackContent = async (options = {}) => {
    const contentStackResource = options.cloudCannonResource
      .replace(/\\|\//g, '')
      .replace(/-/g, '_')
      .replace('.json', '')

    const contentStackUrl = contentUrl()
    const fetchUrl = `${contentStackUrl}${contentStackResource}/en-us/content.json`

    const resource = await this._makeRequest(fetchUrl, {
      method: 'GET'
      // headers: this.headers
    })

    return formatContentStackResponse(resource, contentStackResource)
  };
}

function formatContentStackResponse(response, contentStackResource) {
  let data = response
  if (data.common) {
    data = { ...data, ...data.common }
  }
  if (contentStackResource === 'resources' && data.resources) {
    formatResources(data)
  }
  if (contentStackResource.startsWith('open_enrollment')) {
    data = formatOE(data)
  }
  return data
}

function formatResources(data) {
  data.resources = data.resources.map(resource => {
    if (!resource.resource) return resource
    const resourceObj = resource.resource
    if (!resourceObj.files) return resourceObj
    resourceObj.files = resourceObj.files.map(file => {
      const fileObj = file.file
      if (fileObj.file_path) {
        fileObj.filePath = fileObj.file_path.url
      }
      return fileObj
    })
    return resourceObj
  })
}

function formatOE(data) {
  let OEData = keysToCamel(data)
  OEData.events = [OEData.digital, OEData.printed, OEData.rep]
  if (OEData.benefit) {
    OEData.events.unshift(OEData.benefit)
  }
  return OEData
}

const keysToCamel = function(o) {
  const toCamel = s => {
    return s.replace(/([-_][a-z])/gi, $1 => {
      return $1
        .toUpperCase()
        .replace('-', '')
        .replace('_', '')
    })
  }
  const isArray = function(a) {
    return Array.isArray(a)
  }
  const isObject = function(o) {
    return o === Object(o) && !isArray(o) && typeof o !== 'function'
  }

  if (isObject(o)) {
    const n = {}

    Object.keys(o).forEach(k => {
      n[toCamel(k)] = keysToCamel(o[k])
    })

    return n
  } else if (isArray(o)) {
    return o.map(i => {
      return keysToCamel(i)
    })
  }

  return o
}
